import { render, staticRenderFns } from "./SliderRGBBase.vue?vue&type=template&id=2918e8ce&"
import script from "./SliderRGBBase.vue?vue&type=script&lang=ts&"
export * from "./SliderRGBBase.vue?vue&type=script&lang=ts&"
import style0 from "./SliderRGBBase.vue?vue&type=style&index=0&id=2918e8ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports